export default __webpack_public_path__ + "static/dheeraj-d74fbaf46272cbf0b48006a3822a1cf3.png";